import { BaseTask } from "@whilecat/core/tasks/base-task.ts";
import { type PropertyValues, css, html } from "lit";
import "@whilecat/core/editors/code-area.ts";
import { publish, subscribe } from "@whilecat/core/events/event-service.js";
import { TASK_COMPLETED } from "@whilecat/core/events/task-events.js";
import { type TextParams, TextParamsValidator } from "@whilecat/core/tasks/common/params/text-params.js";
import { isAbsent, isPresent } from "@whilecat/core/utils/objects.js";
import WhilecatStyle from "@whilecat/core/whilecat-style.js";
import { customElement } from "lit/decorators.js";

@customElement("text-block-task")
export class TextBlockTask extends BaseTask<TextParams> {
    static styles = [
        WhilecatStyle,
        super.styles,
        css`
          :host {
            display: block;
            width: 100%;
          }

          p {
            word-wrap: break-word;
          }

          .content {
            text-align: left;
          }
        `,
    ];

    private paramsValidator = new TextParamsValidator();

    static html(taskId: string, data: TextParams, completed: boolean, repetitionMode: boolean) {
        return html`
          <text-block-task
                  .taskId=${taskId}
                  .data=${data}
                  .completed="${completed}"
                  .repetitionMode="${repetitionMode}">
          </text-block-task>`;
    }

    firstUpdated(_changedProperties: PropertyValues) {
        super.firstUpdated(_changedProperties);

        if (isPresent(this.data.customCompletionEvent)) {
            subscribe(this.data.customCompletionEvent, () => this._completeTask());
        }
    }

    protected updated(_changedProperties: PropertyValues) {
        super.updated(_changedProperties);
        if (isAbsent(this.data.customCompletionEvent) && !this.completed) {
            this._completeTask();
        }
    }

    override _completeTask() {
        publish(TASK_COMPLETED, { taskId: this.taskId, gaveUp: false });
    }

    override render() {
        return html`
          <div class="content">
            ${this.data.content}
          </div>
        `;
    }

    override validateData() {
        this.paramsValidator.validate(this.data);
    }
}
